module.exports = __webpack_public_path__ + "static/media/209-Patientenakte_ID_20.7a422db5.mp3";